import React from "react";
import { Toolbar, ToolbarGroup } from "../Toolbar";
import { Button, ButtonGroup, InputGroup } from "@blueprintjs/core";
import { Icon } from "../../atoms/Icon";
import { FilterToolbar } from "../FilterToolbar";

function VideoPageHeader({
  onSearchTextChange,
  onUploadPress,
  filters,
  setFilters,
  filterOptions,
  uploadBtnText,
  searchText,
  disableAddVideo
}) {
  return (
    <Toolbar title="Videos">
      <ToolbarGroup>
        <InputGroup
          type="search"
          placeholder="Search..."
          value={searchText}
          leftIcon={<Icon name="search" color="#8a9ba8" />}
          onChange={onSearchTextChange}
        />
      </ToolbarGroup>

      <FilterToolbar
        value={filters}
        onChange={setFilters}
        filterOptions={filterOptions}
      />

      <ToolbarGroup>
        <ButtonGroup>
          <Button
            icon="plus"
            className="narrow bold"
            text={uploadBtnText || 'Add Video'}
            onClick={onUploadPress}
            disabled={disableAddVideo}
          />
        </ButtonGroup>
      </ToolbarGroup>
    </Toolbar>
  );
}

export default VideoPageHeader;
